import React, { useEffect, useState } from 'react';

import { ViewFilters } from '@uncinc/react-drupal-core';
import { FormCheckbox, FormikWrapper, FormSelect, FormTextField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const TextField = ({ filter, onChange }) => {
  let t = null;

  const _onChange = (value) => {
    if (t) {
      clearTimeout(t);
    }

    t = setTimeout(() => {
      onChange(value);
    }, 500);
  };

  return (
    <FormTextField
      title={filter.getIn(['expose', 'label'])}
      placeholder={filter.getIn(['expose', 'placeholder'])}
      fieldName={filter.getIn(['field'])}
      handleChange={() => {}}
      onChange={(e) => _onChange(e.target.value)}
    />
  );
};

const CustomViewFilters = ({ viewId, display, onUpdate, defaultFilters = {} }) => {
  const [filters, setFilters] = useState(defaultFilters);

  const updateFilter = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    // For e.g. checkboxes, we fully want to remove the filter, because we
    // do want the "any" value, not the "not" value.
    if (value === 0) {
      delete newFilters[field];
    }

    setFilters(newFilters);
  };

  const resetFilter = (field) => {
    delete filters[field];
    setFilters({ ...filters });
  };

  useEffect(() => {
    onUpdate(filters);
  }, [filters, onUpdate]);

  return (
    <FormikWrapper>
      <ViewFilters
        viewId={viewId}
        display={display}
        onFilterUpdate={(field, value) => { updateFilter(field, value); }}
        onResetFilter={(field) => { resetFilter(field); }}
        onRender={(data) => {
          const { filter, onChange } = data;

          switch (filter.get('plugin_id')) {
            case 'boolean': {
              return (
                <div className="ViewFilters__filter">
                  <FormCheckbox
                    title={filter.getIn(['expose', 'label'])}
                    fieldName={filter.getIn(['field'])}
                    onChange={(value) => onChange(filter.getIn(['expose', 'identifier']), value ? 1 : 0)}
                  />
                </div>
              );
            }

            case 'combine':
            case 'string': {
              return (
                <div className="ViewFilters__filter">
                  <TextField
                    filter={filter}
                    onChange={(value) => onChange(filter.getIn(['expose', 'identifier']), value)}
                  />
                </div>
              );
            }

            case 'entity_reference_tree_inline_filter': {
              const defaultValue = filter.get('options').find((item) => { return item.get('value') === filters[filter.getIn(['expose', 'identifier'])]; }) || null;
              return (
                <div className="ViewFilters__filter">
                  <FormSelect
                    title={filter.getIn(['expose', 'label'])}
                    fieldName={filter.getIn(['field'])}
                    options={filter.get('options').toJS()}
                    selectedOption={defaultValue ? defaultValue.toJS() : null}
                    onChange={(value) => onChange(filter.getIn(['expose', 'identifier']), value)}
                  />
                </div>
              );
            }

            default: {
              return null;
            }
          }
        }}
      />
    </FormikWrapper>
  );
};

export default CustomViewFilters;
